import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarLeftArrow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSidebarLeftArrow"><Path d="M15.5 9.5L13 12L15.5 14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 3.5H20.5V20.5H3.5V3.5Z" stroke="currentColor"/><Path d="M8.5 3.5V20.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconSidebarLeftArrow;
